import * as React from 'react';
import { ReactComponent as LogoSvg } from '../../assets/logo-mark.svg';

type Props = React.SVGProps<SVGSVGElement>;

export function LogoMark(props: Props) {
  return <LogoSvg aria-hidden="true" focusable="false" {...props} />;
}
